import AccountRoutes from "./modules/account/routes";
import CheckSubRoutes from "./modules/check/routes";
import ConfigSubRoutes from "./modules/config/routes";
import RegisterSubRoutes from "./modules/register/routes";
import SupportRoutes from "./modules/support/routes";
import TotemRoutes from "./modules/totem/routes";

const routes = [].concat(AccountRoutes, SupportRoutes, TotemRoutes)
const subRoutes = [].concat(RegisterSubRoutes, ConfigSubRoutes, CheckSubRoutes)
export { routes, subRoutes }